<template>
  <div class="newsletter">
    <div class="heading-3-bold popup-title" v-html="popup.sections.main.fields.value.title"></div>
    <div class="lead-1 popup-subtitle" v-html="popup.sections.main.fields.value.subTitle"></div>
    <div class="main-content paragraph-1" v-html="popup.sections.main.fields.value.text"></div>
    <seu-email-input
      :placeholder="$t('newsletter.enter_email')"
      :button-label="popup.sections.main.fields.value.buttonLabel"
    />
  </div>
</template>

<script>
import SeuEmailInput from "/seu-frontend/components/SeuEmailInput";

export default {
  name: 'Newsletter',
  components: {SeuEmailInput},
  computed: {
    popup() {
      return require(`../../services/pages/${this.$store.state.currentLanguage.toLowerCase()}/newsletter`).default;
    }
  },
  props: {
    items: {
      type: Object,
    }
  }
}
</script>

<style lang="scss">
@import "Newsletter.scss";
</style>
